<template>
  <div :class="isError ? 'text-danger' : 'text-success'">
    {{ result }}
  </div>
</template>

<script>
import { services } from "../services/services";

export default {
  data() {
    return {
      result: "Povezujem Google Health...",
      isError: false,
    };
  },
  mounted() {
    const params = new URL(location.href).searchParams;
    const oauthError = params.get("error");
    if (oauthError) {
      this.isError = true;
      this.result = `Google autorizacija nije uspjela: ${oauthError}`;
      return;
    }

    services.completeGoogleHealthAuthorization(params.get("code"), params.get("state"))
      .then((response) => {
        this.result = response.body;
      })
      .catch((response) => {
        this.isError = true;
        this.result = response?.body?.error || "Povezivanje Google Healtha nije uspjelo.";
      });
  },
};
</script>
